export default "__VITE_ASSET__BbvS4jbm__"